exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  position: relative; }\n  form button {\n    position: absolute;\n    right: 0;\n    top: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/shared/filter/filter.component.scss
// module id = ../../../../../src/app/shared/filter/filter.component.scss
// module chunks = main